import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { InputNumberField } from '@saucelabs/sl-component-form';
import validate from '@saucelabs/sl-util-validate';

const name = 'setGroupConcurrency';

const SetGroupConcurrencyForm = ({ currentVM, handleSubmit, maxVM }) => (
  <form onSubmit={handleSubmit}>
    <InputNumberField
      initialValue={currentVM}
      maxValue={maxVM}
      name="virtual_machines"
    />
  </form>
);

SetGroupConcurrencyForm.propTypes = {
  currentVM: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  maxVM: PropTypes.number.isRequired,
};

const constraints = { virtual_machines: { presence: { allowEmpty: false } } };

const ConnectedSetGroupConcurrencyForm = reduxForm({
  form: name,
  onSubmit: (values, dispatch, formProps) => formProps.setConcurrency(values),
  validate: (values) => validate(values, constraints, { format: 'grouped' }),
})(SetGroupConcurrencyForm);

ConnectedSetGroupConcurrencyForm.propTypes = {
  setConcurrency: PropTypes.func.isRequired,
};

export default ConnectedSetGroupConcurrencyForm;
export { name, ConnectedSetGroupConcurrencyForm, SetGroupConcurrencyForm };
